import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
  Injector,
  ComponentFactoryResolver,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { SidePanelService, SidePanelContent } from '../../services/side-panel.service';
import { SidePanelRef } from '../../models/side-panel-ref';
import { SIDE_PANEL_CONTEXT } from '../../tokens/side-panel.tokens';

@Component({
  selector: 'app-side-panel-wrapper',
  templateUrl: './side-panel-wrapper.component.html',
  styleUrls: ['./side-panel-wrapper.component.scss'],
})
export class SidePanelWrapperComponent implements OnInit, OnDestroy {
  @ViewChild('contentAnchor', { read: ViewContainerRef, static: false })
  private contentAnchor: ViewContainerRef;

  currentContent: SidePanelContent<any> | null = null;
  private contentSub: Subscription;

  constructor(
    public sidePanelService: SidePanelService,
    private injector: Injector,
    private componentFactoryResolver: ComponentFactoryResolver
  ) {}

  ngOnInit(): void {
    this.contentSub = this.sidePanelService.currentContent$.subscribe(content => {
      this.currentContent = content;

      setTimeout(() => {
        this.loadComponent();
      });
    });
  }

  private loadComponent(): void {
    if (!this.currentContent || !this.contentAnchor) {
      return;
    }

    this.contentAnchor.clear();

    const panelRef = new SidePanelRef(this.sidePanelService, this.currentContent.data);
    const customInjector = Injector.create({
      providers: [{ provide: SIDE_PANEL_CONTEXT, useValue: panelRef }],
      parent: this.injector,
    });
    
    const factory = (this as any).componentFactoryResolver.resolveComponentFactory(
        this.currentContent.component
      );
    this.contentAnchor.createComponent(factory, undefined, customInjector);
  }
  
  onClose(): void {
    this.sidePanelService.dismiss();
  }

  onBack(): void {
    this.sidePanelService.navigateBack();
  }

  ngOnDestroy(): void {
    if (this.contentSub) {
      this.contentSub.unsubscribe();
    }
  }
}